var map = {
	"./locale_cn.png": 5478,
	"./locale_en.png": 3434,
	"./locale_kh.png": 2202,
	"./locale_kr.png": 2921,
	"./locale_ru.png": 9128,
	"./locale_tw.png": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4344;